import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { paragraphSmall } from '@helpers/typography';
import { LinkButton } from '@stories/Components/Buttons/Button/Button';
import styled from 'styled-components';
import { ArticleCardStyles } from '../ArticleCard/ArticleCard.styles';
import { InformationCardStyles } from '../InformationCard/InformationCard.styles';
const Container = styled(ArticleCardStyles.Container) ``;
const ImageWrapper = styled(ArticleCardStyles.ImageWrapper) ``;
const CategoryTag = styled(ArticleCardStyles.CategoryTag) ``;
const ImageLink = styled.a ``;
const Image = styled.img `
  max-width: none;
  width: 100%;
  height: auto;
  ${transition('transform')};
  transform-origin: 50% 50%;

  ${ImageLink}:hover &,
  ${Container}:is(a):hover & {
    transform: scale(1.1);
  }

  ${Container}[data-featured] & {
    height: 100%;
    object-fit: cover;
  }
`;
const CardContent = styled(InformationCardStyles.Content) `
  ${Container}[data-featured] & {
    background-color: var(--themeColor);
    padding: 20px 30px;
  }
`;
const Title = styled(ArticleCardStyles.Title) ``;
const Content = styled.p `
  ${paragraphSmall};
  margin-bottom: 10px;

  ${Container}[data-featured] & {
    color: ${brand.white};
  }
`;
const ArticleInfo = styled.div ``;
const ArticleInfoItem = styled(ArticleCardStyles.ArticleInfoItem) ``;
const ArticleInfoItemIcon = styled.div `
  display: flex;
  align-items: center;
  width: 17px;
  margin-right: 7px;
`;
const CardFooter = styled(InformationCardStyles.CardFooter) ``;
const Price = styled(InformationCardStyles.HighlightText) `
  color: var(--themeColor);

  ${Container}[data-featured] & {
    color: ${brand.white};
  }
`;
const CtaList = styled(InformationCardStyles.CtaList) ``;
const Cta = styled(LinkButton) `
  &&& {
    --buttonHeight: auto;
  }

  ${Container}[data-featured] & {
    --buttonFgColor: ${brand.white};
    --buttonBorderColor: ${brand.white};
  }
`;
const AdditionalCta = styled(LinkButton) `
  &&& {
    --buttonHeight: auto;
  }
`;
export const EventCardStyles = {
    AdditionalCta,
    CardContent,
    CardFooter,
    CategoryTag,
    Container,
    Content,
    Cta,
    CtaList,
    ArticleInfo,
    ArticleInfoItem,
    ArticleInfoItemIcon,
    Image,
    ImageLink,
    ImageWrapper,
    Price,
    Title,
};
